import { AppRoutes } from "@/routes/config";
import { createUrlWithParams } from "@/utils/url";

// UI URL of the irohana-center admin app (never the API host). Center owns auth:
// an unauthenticated visitor lands on its login, an authenticated one on its home.
const CENTER_ADMIN_URL = process.env.REACT_APP_CENTER_ADMIN_URL;

// Forwards to the in-app `/login` bridge, preserving the target page so it can be
// restored after the center SSO round-trip via `/auth/callback`.
export const redirectToLogin = (): void => {
  if (window.location.pathname === AppRoutes.login) {
    window.location.replace(AppRoutes.login);
    return;
  }

  const redirectUrl = `${window.location.pathname}${window.location.search}`;
  window.location.replace(createUrlWithParams(AppRoutes.login, { redirectUrl }));
};

// `replace: true` drops the current page from history — use when auth kicks the user
// out. Default keeps it so the back button returns here when the user leaves by choice.
export const redirectToCenter = ({ replace = false }: { replace?: boolean } = {}): void => {
  const url = CENTER_ADMIN_URL || "/";
  if (replace) {
    window.location.replace(url);
  } else {
    window.location.href = url;
  }
};
